import React from 'react';
import dayjs from 'dayjs';
import styled, { css } from 'styled-components';
import { TExamsDetails } from 'app.type/examsDetails';
import { TExamLabelType } from 'app.type/examLabelType';
import { ExamTypeLabels } from 'app.feature/academy/cbt.detail/constant/examLabels';

const CbtRoundTablePc = ({ displayedExams, examInfo, handleSolveButtonClick }: any) => {
  return (
    <TableWrapper>
      <table>
        <thead>
          <tr>
            <th>시험명</th>
            <th>시험 유형</th>
            <th>문제 수</th>
            <th>문제 푼 인원 수</th>
            <th>조회수</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {displayedExams?.map((exam: TExamsDetails, index: number) => (
            <tr key={index}>
              <td>
                <span>{`${examInfo.examName} ${exam?.examDateOrNull?.substr(0, 4)}년 ${
                  exam.examRound
                }`}</span>
                {exam?.recentExamDetailSolves?.at(0)?.updatedAt && (
                  <small>
                    최근 풀이일 :{' '}
                    {dayjs(exam?.recentExamDetailSolves?.at(0)?.updatedAt).format('YYYY-MM-DD')}
                  </small>
                )}
              </td>
              <td>{ExamTypeLabels[exam.type as TExamLabelType]}</td>
              <td>{Number(exam.problemCount).toLocaleString()}</td>
              <td>{Number(exam.solvedCount).toLocaleString()}</td>
              <td>{Number(exam.viewCount).toLocaleString()}</td>
              <td>
                <button
                  onClick={() => {
                    handleSolveButtonClick(exam.examDetailIdx);
                  }}
                  className="btn-cbt"
                >
                  풀기
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableWrapper>
  );
};

export default CbtRoundTablePc;

const commonFontStyles = css`
  color: #333;
  font-weight: 500;
`;

const TableWrapper = styled.div`
  max-width: 1148px;
  margin: 50px auto;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    background: #fff;
    @media ${({ theme }) => theme.device.mobile} {
      display: none;
    }

    thead {
      background-color: #fff;

      th {
        ${commonFontStyles};
        height: 56px;
        padding: 0 15px;
        border-top: 1px solid #666;
        border-bottom: 1px solid #e0e0e0;
        font-size: 15px;
        text-align: center;
        &:first-child {
          text-align: left;
        }
      }
    }

    tbody {
      tr {
        box-sizing: border-box;
        height: 95px;

        td {
          ${commonFontStyles};
          font-size: 16px;
          text-align: center;
          padding: 0 15px;
          border-bottom: 1px solid #e0e0e0;
          &:first-child {
            text-align: left;
            > span {
              ${commonFontStyles};
              font-size: 16px;
              display: block;
              line-height: initial;
              margin-bottom: 6px;
            }
            > small {
              font-size: 15px;
              color: #01a0ff;
              font-weight: 500;
              display: block;
              line-height: initial;
            }
          }
        }
        .btn-cbt {
          height: 50px;
          line-height: 50px;
          border: 1px solid #01a0ff;
          border-radius: 8px;
          color: #01a0ff;
          padding: 0 20px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
        }
      }
    }
  }
`;
